module.exports = __webpack_public_path__ + "zl17-cf2a2f5b.png";